import { useMemo } from "react";
import { useSelector } from "react-redux";

import type { User } from "./authSlice";

import type { NavigationPersona } from "@/features/feature.types";
import type { RootState } from "@/redux/store";

function normalize(value?: string | null) {
  return String(value ?? "")
    .trim()
    .toLowerCase();
}

export function isGuardianUser(user?: User | null): boolean {
  if (!user) {
    return false;
  }

  if (user.dataScope === "Linked") {
    return true;
  }

  if (user.role === "parent" || normalize(user.key) === "guardian") {
    return true;
  }

  if (normalize(user.activeContext) === "guardian") {
    return true;
  }

  return false;
}

export function useNavigationPersona(): NavigationPersona {
  const user = useSelector((state: RootState) => state.auth.user);

  return useMemo<NavigationPersona>(
    () => (isGuardianUser(user) ? "guardian" : "staff"),
    [user],
  );
}
